"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class EvaluatorCertificationSubscription {
  static thaw(evaluatorCertificationSubscriptionObj) {
    if (evaluatorCertificationSubscriptionObj == null) return null;
    const evaluatorCertificationSubscription = new EvaluatorCertificationSubscription();
    if (evaluatorCertificationSubscriptionObj.id != null) evaluatorCertificationSubscription.setId(evaluatorCertificationSubscriptionObj.id);
    if (evaluatorCertificationSubscriptionObj.subscriptionStart != null) evaluatorCertificationSubscription.setSubscriptionStart(_luxon.DateTime.fromISO(evaluatorCertificationSubscriptionObj.subscriptionStart));
    if (evaluatorCertificationSubscriptionObj.subscriptionEnd != null) evaluatorCertificationSubscription.setSubscriptionEnd(_luxon.DateTime.fromISO(evaluatorCertificationSubscriptionObj.subscriptionEnd));
    if (evaluatorCertificationSubscriptionObj.evaluatorCertificationId != null) evaluatorCertificationSubscription.setEvaluatorCertificationId(evaluatorCertificationSubscriptionObj.evaluatorCertificationId);
    if (evaluatorCertificationSubscriptionObj.evaluatorCertification != null) evaluatorCertificationSubscription.setEvaluatorCertification(_.EvaluatorCertification.thaw(evaluatorCertificationSubscriptionObj.evaluatorCertification));
    if (evaluatorCertificationSubscriptionObj.stripeSubscriptionId != null) evaluatorCertificationSubscription.setStripeSubscriptionId(evaluatorCertificationSubscriptionObj.stripeSubscriptionId);
    if (evaluatorCertificationSubscriptionObj.subscriptionTier != null) evaluatorCertificationSubscription.setSubscriptionTier(_.SubscriptionTier.thaw(evaluatorCertificationSubscriptionObj.subscriptionTier));
    if (evaluatorCertificationSubscriptionObj.numEvaluationsRemaining != null) evaluatorCertificationSubscription.setNumEvaluationsRemaining(evaluatorCertificationSubscriptionObj.numEvaluationsRemaining);
    if (evaluatorCertificationSubscriptionObj.isPendingCancellation != null) evaluatorCertificationSubscription.setIsPendingCancellation(evaluatorCertificationSubscriptionObj.isPendingCancellation);
    if (evaluatorCertificationSubscriptionObj.newSubscriptionTier != null) evaluatorCertificationSubscription.setNewSubscriptionTier(_.SubscriptionTier.thaw(evaluatorCertificationSubscriptionObj.newSubscriptionTier));
    if (evaluatorCertificationSubscriptionObj.stripeSubscriptionScheduleId != null) evaluatorCertificationSubscription.setStripeSubscriptionScheduleId(evaluatorCertificationSubscriptionObj.stripeSubscriptionScheduleId);
    return evaluatorCertificationSubscription;
  }

  static thawList(evaluatorCertificationSubscriptionObjList) {
    if (evaluatorCertificationSubscriptionObjList == null) return [];
    var evaluatorCertificationSubscriptions = [];

    for (var i = 0; i < evaluatorCertificationSubscriptionObjList.length; i++) {
      evaluatorCertificationSubscriptions.push(EvaluatorCertificationSubscription.thaw(evaluatorCertificationSubscriptionObjList[i]));
    }

    return evaluatorCertificationSubscriptions;
  }

  static freeze(evaluatorCertificationSubscription) {
    if (evaluatorCertificationSubscription == null) return null;
    var evaluatorCertificationSubscriptionObj = {};
    if (evaluatorCertificationSubscription.getId() != null) evaluatorCertificationSubscriptionObj.id = evaluatorCertificationSubscription.getId();
    if (evaluatorCertificationSubscription.getSubscriptionStart() != null) evaluatorCertificationSubscriptionObj.subscriptionStart = evaluatorCertificationSubscription.getSubscriptionStart();
    if (evaluatorCertificationSubscription.getSubscriptionEnd() != null) evaluatorCertificationSubscriptionObj.subscriptionEnd = evaluatorCertificationSubscription.getSubscriptionEnd();
    if (evaluatorCertificationSubscription.getEvaluatorCertificationId() != null) evaluatorCertificationSubscriptionObj.evaluatorCertificationId = evaluatorCertificationSubscription.getEvaluatorCertificationId();
    if (evaluatorCertificationSubscription.getEvaluatorCertification() != null) evaluatorCertificationSubscriptionObj.evaluatorCertification = _.EvaluatorCertification.freeze(evaluatorCertificationSubscription.getEvaluatorCertification());
    if (evaluatorCertificationSubscription.getStripeSubscriptionId() != null) evaluatorCertificationSubscriptionObj.stripeSubscriptionId = evaluatorCertificationSubscription.getStripeSubscriptionId();
    if (evaluatorCertificationSubscription.getSubscriptionTier() != null) evaluatorCertificationSubscriptionObj.subscriptionTier = _.SubscriptionTier.freeze(evaluatorCertificationSubscription.getSubscriptionTier());
    if (evaluatorCertificationSubscription.getNumEvaluationsRemaining() != null) evaluatorCertificationSubscriptionObj.numEvaluationsRemaining = evaluatorCertificationSubscription.getNumEvaluationsRemaining();
    if (evaluatorCertificationSubscription.getIsPendingCancellation() != null) evaluatorCertificationSubscriptionObj.isPendingCancellation = evaluatorCertificationSubscription.getIsPendingCancellation();
    if (evaluatorCertificationSubscription.getNewSubscriptionTier() != null) evaluatorCertificationSubscriptionObj.numEvaluationsRemaining = evaluatorCertificationSubscription.getNewSubscriptionTier();
    if (evaluatorCertificationSubscription.getStripeSubscriptionScheduleId() != null) evaluatorCertificationSubscriptionObj.stripeSubscriptionScheduleId = evaluatorCertificationSubscription.getStripeSubscriptionScheduleId();
    return evaluatorCertificationSubscriptionObj;
  }

  static freezeList(evaluatorCertificationSubscriptions) {
    if (evaluatorCertificationSubscriptions == null) return [];
    var evaluatorCertificationSubscriptionObjList = [];

    for (var i = 0; i < evaluatorCertificationSubscriptions.length; i++) {
      evaluatorCertificationSubscriptionObjList.push(EvaluatorCertificationSubscription.freeze(evaluatorCertificationSubscriptions[i]));
    }

    return evaluatorCertificationSubscriptionObjList;
  }

  constructor() {
    this.setId(null);
    this.setSubscriptionStart(null);
    this.setSubscriptionEnd(null);
    this.setEvaluatorCertificationId(null);
    this.setEvaluatorCertification(null);
    this.setStripeSubscriptionId(null);
    this.setSubscriptionTier(null);
    this.setNumEvaluationsRemaining(null);
    this.setIsPendingCancellation(null);
    this.setStripeSubscriptionScheduleId(null);
    this.setNewSubscriptionTier(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setSubscriptionStart(subscriptionStart) {
    this.subscriptionStart = subscriptionStart;
  }

  setSubscriptionEnd(subscriptionEnd) {
    this.subscriptionEnd = subscriptionEnd;
  }

  setEvaluatorCertificationId(evaluatorCertificationId) {
    this.evaluatorCertificationId = evaluatorCertificationId;
  }

  setEvaluatorCertification(evaluatorCertification) {
    this.evaluatorCertification = evaluatorCertification;
  }

  setStripeSubscriptionId(stripeSubscriptionId) {
    this.stripeSubscriptionId = stripeSubscriptionId;
  }

  setSubscriptionTier(subscriptionTier) {
    this.subscriptionTier = subscriptionTier;
  }

  setNumEvaluationsRemaining(numEvaluationsRemaining) {
    this.numEvaluationsRemaining = numEvaluationsRemaining;
  }

  setIsPendingCancellation(isPendingCancellation) {
    this.isPendingCancellation = isPendingCancellation;
  }

  setNewSubscriptionTier(newSubscriptionTier) {
    this.newSubscriptionTier = newSubscriptionTier;
  }

  setStripeSubscriptionScheduleId(stripeSubscriptionScheduleId) {
    this.stripeSubscriptionScheduleId = stripeSubscriptionScheduleId;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getSubscriptionStart() {
    return this.subscriptionStart;
  }

  getSubscriptionEnd() {
    return this.subscriptionEnd;
  }

  getEvaluatorCertificationId() {
    return this.evaluatorCertificationId;
  }

  getEvaluatorCertification() {
    return this.evaluatorCertification;
  }

  getStripeSubscritionId() {
    return this.stripeSubscriptionId;
  }

  getSubscriptionTier() {
    return this.subscriptionTier;
  }

  getNumEvaluationsRemaining() {
    return this.numEvaluationsRemaining;
  }

  getIsPendingCancellation() {
    return this.isPendingCancellation;
  }

  getNewSubscriptionTier() {
    return this.newSubscriptionTier;
  }

  getStripeSubscriptionScheduleId() {
    return this.stripeSubscriptionScheduleId;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluatorCertificationSubscription;